export default function (question, text, type, buttons, allowClose) {
  if (buttons === undefined || !Array.isArray(buttons))
    buttons = [
      {
        type: 'no',
        name: 'Nee'
      },
      {
        type: 'yes',
        name: 'Ja'
      },
    ];

  if (type === undefined || typeof type !== 'string')
    type = 'warning';

  let confirm = this.$root.$children[0].$refs.confirm;

  confirm.title = question;
  confirm.content = text;
  confirm.type = type;
  confirm.actions = buttons;

  confirm.open = true;

  return new Promise((resolve) => {
    confirm.$off('close');
    confirm.$on('close', function () {
      if(allowClose) {
        confirm.open = false;
        confirm.$off('close');
        resolve('close')
      }
    });

    confirm.$off('action');
    confirm.$on('action', function (test) {
      confirm.open = false;
      confirm.$off('action');
      resolve(test);
    })
  })
}
